
import * as models from "app/models/requireme";
import { resources } from "app/main/std";

export async function setDescripciones(x: models.BitacoraRADPaquete): Promise<models.BitacoraRADPaqueteDto> {
    const contenidoPaquete = await resources.ContenidoPaquete.getMemo(x.IdContenidoPaquete);
    const descPaquete = await resources.DescripcionPaquete.getMemo(x.IdDescripcionPaquete);
    
    const ret: models.BitacoraRADPaqueteDto = {
        ...x,
        NombreContenidoPaquete: contenidoPaquete.Nombre, 
        NombreDescripcionPaquete: descPaquete.Nombre
    }

    return ret;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/edit/paquetes/logic.tsx